import React, { ReactNode } from 'react';
import { Button, Grid, IconButton, Typography } from '@mui/material';

export function ShareOption(props: {
  icon: ReactNode;
  buttonText: string;
  fullText: string;
  disabled?: boolean;
  onClick: () => void;
}) {
  return (
    <Grid container spacing={1}>
      <Grid size={4}>
        <IconButton
          color="primary"
          sx={{ margin: 'auto', display: { xs: 'flex', md: 'none' } }}
          disabled={props.disabled}
          onClick={props.onClick}
        >
          {props.icon}
        </IconButton>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          sx={{ marginRight: 1, whiteSpace: 'nowrap', display: { xs: 'none', md: 'flex' } }}
          startIcon={props.icon}
          disabled={props.disabled}
          onClick={props.onClick}
        >
          {props.buttonText}
        </Button>
      </Grid>
      <Grid size={8} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Typography variant="body2" color={props.disabled ? 'textDisabled' : 'textPrimary'}>
          {props.fullText}
        </Typography>
      </Grid>
    </Grid>
  );
}
